import { ApiInstance } from '@src/services/api-instance';
import { ToolsV1Service } from './modules/v1/tools-api-v1';

export class ToolsApi {
  private readonly client: ApiInstance;

  public v1: ToolsV1Service;

  constructor(client?: ApiInstance) {
    this.client = client || new ApiInstance(`${import.meta.env.VITE_TOOLS_BASE_URL}`, 30000);

    this.v1 = new ToolsV1Service(this.client);
  }
}
